module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wbx_mail"
  }, [_c('x-input', {
    attrs: {
      "required": _vm.required,
      "placeholder": "请输入邮箱账号",
      "placeholder-align": "right",
      "is-type": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }, [_c('label', {
    staticClass: "weui-label",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("邮箱账号")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "30px 20px"
    }
  }, [_c('x-button', {
    staticClass: "btn-new-sty",
    attrs: {
      "disabled": _vm.loadingShow,
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClick('/fpjdetail/')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.btnText) + "\n        ")])], 1), _vm._v(" "), _c('alert', {
    model: {
      value: (_vm.warnMsgShow),
      callback: function($$v) {
        _vm.warnMsgShow = $$v
      },
      expression: "warnMsgShow"
    }
  }, [_vm._v(_vm._s(_vm.warnMsg))]), _vm._v(" "), _c('toast', {
    attrs: {
      "time": "3000"
    },
    model: {
      value: (_vm.toastShow),
      callback: function($$v) {
        _vm.toastShow = $$v
      },
      expression: "toastShow"
    }
  }, [_vm._v(_vm._s(_vm.toastMsg))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('loading', {
    attrs: {
      "text": _vm.loadingText
    },
    model: {
      value: (_vm.loadingShow),
      callback: function($$v) {
        _vm.loadingShow = $$v
      },
      expression: "loadingShow"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0a03e84"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fpj/mail.vue
// module id = 349
// module chunks = 0